<template>
  <div class="xjsrdzd-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="打款日期">
              <el-date-picker
                v-model="searchForm.time"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                type="daterange"
                style="width:300px"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="打款性质">
              <el-select v-model="searchForm.type" style="width: 130px" clearable>
                <el-option label="订单收款" :value="0"></el-option>
                <el-option label="收款抹零" :value="4"></el-option>
                <el-option label="返点抵款" :value="5"></el-option>
                <el-option label="售后赔款" :value="6"></el-option>
                <el-option label="划帐" :value="8"></el-option>
                <el-option label="报备金冲抵" :value="7"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="打款内容">
              <el-select v-model="searchForm.paycontent" style="width: 130px" clearable>
                <el-option
                  v-for="item in paycontentList"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
            <br>
            <el-form-item label="操作日期">
              <el-date-picker
                v-model="searchForm.opertime"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                type="daterange"
                style="width:300px"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="关键字">
              <el-input v-model="searchForm.search" style="width:200px" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search()">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" :loading="pringLoading" @click="Print">打印对账单</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" :loading="excelLoading" @click="exportExcel">导出Excel</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-table
              v-loading="loading"
              :data="tableData"
              stripe
              :row-style="{cursor: 'pointer'}"
              @row-click="openDetails"
              style="width: 100%">
              <el-table-column
                label="打款日期"
                width="140"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{scope.row.receipttime}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="客户"
                width="120"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{scope.row.delname}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="终端客户"
                width="180"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{scope.row.address}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="订单号"
                width="140"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{scope.row.orderNum}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="生产单号"
                width="120"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span style="font-weight: 500;color:#409EFF" v-if="scope.row.productNum!==null&&scope.row.productNum!==''&&scope.row.productNum!==undefined">{{scope.row.productNum}}</span>
                  <span style="font-weight: 500;color:#999999" v-if="scope.row.productNum===null||scope.row.productNum===''||scope.row.productNum===undefined">N/A</span>
                </template>
              </el-table-column>
              <el-table-column
                label="总金额"
                width="100"
                align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{scope.row.totalamount}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="折扣"
                width="70"
                align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.discount>0" type="danger">{{scope.row.discount}}折</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.discount<=0" type="info">0折</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="打款性质"
                width="120"
                align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.type===0||scope.row.type===3||scope.row.type===9">订单收款</span>
                  <span v-if="scope.row.type===4">收款抹零</span>
                  <span v-if="scope.row.type===5">返点抵款</span>
                  <!--<span v-if="scope.row.type===6">售后赔款</span>-->
                  <span v-if="scope.row.type===6&&scope.row.afterType===0">售后赔款</span>
                  <span v-if="scope.row.type===6&&scope.row.afterType===1">划账</span>
                  <span v-if="scope.row.type===7">报备金冲抵</span>
                </template>
              </el-table-column>
              <el-table-column
                label="打款内容"
                width="120"
                align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{scope.row.paycontent}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="卡号"
                width="120"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.card!==null&&scope.row.card!==''&&scope.row.card!==undefined">{{scope.row.card}}</span>
                  <span v-if="scope.row.card===null||scope.row.card===''||scope.row.card===undefined">N/A</span>
                </template>
              </el-table-column>
              <el-table-column
                label="备注"
                min-width="180"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.remark!==null&&scope.row.remark!==''&&scope.row.remark!==undefined">{{scope.row.remark}}</span>
                  <span v-if="scope.row.remark===null||scope.row.remark===''||scope.row.remark===undefined">N/A</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作时间"
                width="150"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  {{scope.row.time}}
                </template>
              </el-table-column>
              <el-table-column
                label="打款金额"
                width="100"
                align="center"
                fixed="right"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span style="color:#409EFF;font-weight: 500;">{{scope.row.money}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="负责人"
                width="120"
                fixed="right"
                align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  {{scope.row.operName}}
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="订单收款详细"
      :visible.sync="collectRecordVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <table class="tcf-detail-table">
        <tr>
          <th>经销商</th>
          <td>{{ dataInfo.delname }}</td>
          <th>操作人</th>
          <td>{{ dataInfo.operName }}</td>
          <th>操作时间</th>
          <td colspan="3">{{ dataInfo.time }}</td>
        </tr>
        <tr>
          <th>订单号</th>
          <td><el-button type="text" size="mini" icon="el-icon-document" @click="goOrder(dataInfo.orderid)">{{ dataInfo.orderNum }}</el-button></td>
          <th>生产单号</th>
          <td>{{ dataInfo.productNum }}</td>
          <th>终端地址</th>
          <td>{{ dataInfo.address }}</td>
        </tr>
        <tr>
          <th>收款日期</th>
          <td>{{ dataInfo.receipttime }}</td>
          <th>收款金额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin"></i> {{dataInfo.money}}</td>
          <th>总金额</th>
          <td style="font-weight: 500;">
            <i class="el-icon-coin"></i>
            <span style="margin-right: 6px">{{dataInfo.totalamount}}</span>
            <el-tag :disable-transitions="true" size="mini" v-if="dataInfo.discount>0" type="danger">{{dataInfo.discount}}折</el-tag>
            <el-tag :disable-transitions="true" size="mini" v-if="dataInfo.discount<=0" type="info">0折</el-tag>
          </td>
        </tr>
        <tr>
          <th>收款性质</th>
          <td>
            <span v-if="dataInfo.type===0||dataInfo.type===3||dataInfo.type===9">订单收款</span>
            <span v-if="dataInfo.type===4">收款抹零</span>
            <span v-if="dataInfo.type===5">返点抵款</span>
            <span v-if="dataInfo.type===6">售后赔款</span>
            <span v-if="dataInfo.type===7">报备金冲抵</span>
          </td>
          <th>收款内容</th>
          <td>{{dataInfo.paycontent}}</td>
          <th>卡号</th>
          <td>{{ dataInfo.card }}</td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="5">{{ dataInfo.remark }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="collectRecordVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="返点抵款详情"
      :visible.sync="viewRebateVisible"
      width="50%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <table class="tcf-detail-table" v-loading="viewRebateLoading">
        <tr>
          <th>审核人</th>
          <td>{{ viewRebatedata.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ viewRebatedata.audittime }}</td>
        </tr>
        <tr>
          <th>返点名称</th>
          <td colspan="5" style="color:#000;">{{ viewRebatedata.name }}</td>
        </tr>
        <tr>
          <th>有效期</th>
          <td colspan="5">
            <span v-if="viewRebatedata.starttime==='0'"><i class="el-icon-date"></i> 无期限</span>
            <span v-if="viewRebatedata.starttime!=='0'"><i class="el-icon-date"></i> {{viewRebatedata.starttime}} ~ {{viewRebatedata.endtime}}</span>
            /
            <span>订单金额满 {{viewRebatedata.orderMoney}} 元以上可享受，同比享受最低折扣不低于 {{viewRebatedata.mindiscount}} 折</span>
          </td>
        </tr>
        <tr>
          <th>返点总额</th>
          <td style="font-weight: 500;"><i class="el-icon-coin"></i> {{ viewRebatedata.amount }}</td>
<!--          <th>返点余额</th>-->
<!--          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin"></i> {{ viewRebatedata.balance }}</td>-->
          <th>抵款方式</th>
          <td>
            <span v-if="viewRebatedata.credit===0">最高冲抵{{viewRebatedata.maximpact}}%</span>
            <span v-if="viewRebatedata.credit===1">享受{{viewRebatedata.maxdiscount}}折</span>
            <span v-if="viewRebatedata.credit===9">任意冲抵</span>
          </td>
          <th>适用订单</th>
          <td>
            <span v-if="viewRebatedata.ordertype===0">无限制</span>
            <span v-if="viewRebatedata.ordertype===1">正单</span>
            <span v-if="viewRebatedata.ordertype===2">补单</span>
          </td>
        </tr>
        <tr>
          <th>返点凭证</th>
          <td colspan="5">
            <el-image v-for="iurl in imgRebateSrcList"
                      style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
                      :src="iurl"
                      :preview-src-list="imgRebateSrcList">
            </el-image>
          </td>
        </tr>
        <tr>
          <th>返点说明</th>
          <td colspan="5">{{ viewRebatedata.remark }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ dataInfo.delname }}</td>
          <th>操作人</th>
          <td>{{ dataInfo.operName }}</td>
          <th>操作时间</th>
          <td colspan="3">{{ dataInfo.time }}</td>
        </tr>
        <tr>
          <th>订单号</th>
          <td><el-button type="text" size="mini" icon="el-icon-document" @click="goOrder(dataInfo.orderid)">{{ dataInfo.orderNum }}</el-button></td>
          <th>生产单号</th>
          <td>{{ dataInfo.productNum }}</td>
          <th>终端地址</th>
          <td>{{ dataInfo.address }}</td>
        </tr>
        <tr>
          <th>抵款日期</th>
          <td>{{ dataInfo.receipttime }}</td>
          <th>抵款金额</th>
          <td>
            <span style="color:#409EFF;font-weight: 500;margin-right: 6px;"><i class="el-icon-coin"></i> {{dataInfo.money}}</span>
            <el-tag :disable-transitions="true" size="mini" type="danger">{{creditPercentage}}%</el-tag>
          </td>
          <th>总金额</th>
          <td>
            <span style="margin-right: 6px;font-weight: 500;"><i class="el-icon-coin"></i> {{dataInfo.totalamount}}</span>
            <el-tag :disable-transitions="true" size="mini" v-if="dataInfo.discount>0" type="danger">{{dataInfo.discount}}折</el-tag>
            <el-tag :disable-transitions="true" size="mini" v-if="dataInfo.discount<=0" type="info">0折</el-tag>
          </td>
        </tr>
        <tr>
          <th>收款性质</th>
          <td>
            <span v-if="dataInfo.type===0||dataInfo.type===3||dataInfo.type===9">订单收款</span>
            <span v-if="dataInfo.type===4">收款抹零</span>
            <span v-if="dataInfo.type===5">返点抵款</span>
            <span v-if="dataInfo.type===6">售后赔款</span>
            <span v-if="dataInfo.type===7">报备金冲抵</span>
          </td>
          <th>收款内容</th>
          <td>{{dataInfo.paycontent}}</td>
          <th>卡号</th>
          <td>{{ dataInfo.card }}</td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="5">{{ dataInfo.remark }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewRebateVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="售后赔款详情"
      :visible.sync="viewAfterVisible"
      width="50%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <table class="tcf-detail-table" v-loading="viewAfterLoading">
        <tr>
          <th>审核人</th>
          <td>{{ viewAfterdata.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ viewAfterdata.audittime }}</td>
        </tr>
        <tr>
          <th>赔款名称</th>
          <td colspan="2" style="color:#000;">{{ viewAfterdata.name }}</td>
          <td colspan="3">
            订单金额满 {{viewAfterdata.orderMoney}} 元以上可冲抵
          </td>
        </tr>
        <tr>
          <th>赔款总额</th>
          <td style="font-weight: 500;"><i class="el-icon-coin"></i> {{ viewAfterdata.amount }}</td>
<!--          <th>账户余额</th>-->
<!--          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin"></i> {{ viewAfterdata.balance }}</td>-->
          <th>抵款方式</th>
          <td>
            <span v-if="viewAfterdata.credit===0">最高冲抵{{viewAfterdata.maximpact}}%</span>
            <span v-if="viewAfterdata.credit===9">任意冲抵</span>
          </td>
          <th>适用订单</th>
          <td>
            <span v-if="viewAfterdata.ordertype===0">无限制</span>
            <span v-if="viewAfterdata.ordertype===1">正单</span>
            <span v-if="viewAfterdata.ordertype===2">补单</span>
          </td>
        </tr>
        <tr>
          <th>赔款凭证</th>
          <td colspan="5">
            <el-image v-for="iurl in imgAfterSrcList"
                      style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
                      :src="iurl"
                      :preview-src-list="imgAfterSrcList">
            </el-image>
          </td>
        </tr>
        <tr>
          <th>赔款说明</th>
          <td colspan="5">{{ viewAfterdata.remark }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ dataInfo.delname }}</td>
          <th>操作人</th>
          <td>{{ dataInfo.operName }}</td>
          <th>操作时间</th>
          <td colspan="3">{{ dataInfo.time }}</td>
        </tr>
        <tr>
          <th>订单号</th>
          <td><el-button type="text" size="mini" icon="el-icon-document" @click="goOrder(dataInfo.orderid)">{{ dataInfo.orderNum }}</el-button></td>
          <th>生产单号</th>
          <td>{{ dataInfo.productNum }}</td>
          <th>终端地址</th>
          <td>{{ dataInfo.address }}</td>
        </tr>
        <tr>
          <th>抵款日期</th>
          <td>{{ dataInfo.receipttime }}</td>
          <th>抵款金额</th>
          <td>
            <span style="color:#409EFF;font-weight: 500;margin-right: 6px;"><i class="el-icon-coin"></i> {{dataInfo.money}}</span>
            <el-tag :disable-transitions="true" size="mini" type="danger">{{creditPercentage}}%</el-tag>
          </td>
          <th>总金额</th>
          <td>
            <span style="margin-right: 6px;font-weight: 500;"><i class="el-icon-coin"></i> {{dataInfo.totalamount}}</span>
            <el-tag :disable-transitions="true" size="mini" v-if="dataInfo.discount>0" type="danger">{{dataInfo.discount}}折</el-tag>
            <el-tag :disable-transitions="true" size="mini" v-if="dataInfo.discount<=0" type="info">0折</el-tag>
          </td>
        </tr>
        <tr>
          <th>收款性质</th>
          <td>
            <span v-if="dataInfo.type===0||dataInfo.type===3||dataInfo.type===9">订单收款</span>
            <span v-if="dataInfo.type===4">收款抹零</span>
            <span v-if="dataInfo.type===5">返点抵款</span>
            <span v-if="dataInfo.type===6">售后赔款</span>
            <span v-if="dataInfo.type===7">报备金冲抵</span>
          </td>
          <th>收款内容</th>
          <td>{{dataInfo.paycontent}}</td>
          <th>卡号</th>
          <td>{{ dataInfo.card }}</td>
        </tr>
        <tr>
          <th>类型</th>
          <td colspan="5" v-if="viewAfterdata.type===0" style="color:#000;">售后赔款</td>
          <td colspan="5" v-if="viewAfterdata.type===1" style="color:#000;">划帐</td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="5">{{ dataInfo.remark }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewAfterVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="报备金冲抵详情"
      :visible.sync="viewReportVisible"
      width="50%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <table class="tcf-detail-table" v-loading="viewReportLoading">
        <tr>
          <th>审核人</th>
          <td>{{ viewReportdata.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ viewReportdata.audittime }}</td>
        </tr>
        <tr>
          <th style="width: 100px">报备金名称</th>
          <td colspan="5" style="color:#000;">{{ viewReportdata.name }}</td>
        </tr>
        <tr>
          <th>报备要求</th>
          <td>
            {{viewReportdata.per}}/单
          </td>
          <th>报备金额</th>
          <td style="font-weight: 500;"><i class="el-icon-coin"></i> {{ viewReportdata.amount }}</td>
          <td colspan="2">
            同比享受最低折扣不低于 {{viewReportdata.mindiscount}} 折
          </td>
        </tr>
        <tr>
          <th>终端地址</th>
          <td colspan="5">
            <table class="tcf-detail-table">
              <tr v-for="(d,index) in viewReportAddress">
                <td style="width: 50px;text-align: center">{{ index+1 }}</td>
                <td>{{ d.address }}</td>
                <td>
                  <span v-if="d.orderid!==null&&d.orderid!==''&&d.orderid!==undefined" style="color:#409EFF;cursor: pointer" @click="goOrder(d.orderid)"><i class="el-icon-document"></i> <span v-if="d.produnum===null||d.produnum===''||d.produnum===undefined">{{d.ordernum}}</span><span v-if="d.produnum!==null&&d.produnum!==''&&d.produnum!==undefined">{{d.produnum}}</span></span>
                  <el-tag :disable-transitions="true" size="mini" v-if="d.orderid===null||d.orderid===''||d.orderid===undefined" type="danger">未关联</el-tag>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <th>有效期</th>
          <td colspan="5">
            <span><i class="el-icon-date"></i> {{viewReportdata.starttime}} ~ {{viewReportdata.endtime}}</span>
          </td>
        </tr>
        <tr>
          <th>对应折扣</th>
          <td colspan="5">
            <table class="tcf-detail-table">
              <tr v-for="(d,index) in viewReportDiscount">
                <td style="width: 50px;text-align: center">{{ index+1 }}</td>
                <td>{{ d.starttime }} 至 {{ d.endtime }}</td>
                <td style="width: 100px;text-align: center">{{ d.discount }}折</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <th>报备凭证</th>
          <td colspan="5">
            <el-image v-for="iurl in imgReportSrcList"
                      style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
                      :src="iurl"
                      :preview-src-list="imgReportSrcList">
            </el-image>
          </td>
        </tr>
        <tr>
          <th>报备说明</th>
          <td colspan="5">{{ viewReportdata.remark }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ dataInfo.delname }}</td>
          <th>操作人</th>
          <td>{{ dataInfo.operName }}</td>
          <th>操作时间</th>
          <td colspan="3">{{ dataInfo.time }}</td>
        </tr>
        <tr>
          <th>订单号</th>
          <td><el-button type="text" size="mini" icon="el-icon-document" @click="goOrder(dataInfo.orderid)">{{ dataInfo.orderNum }}</el-button></td>
          <th>生产单号</th>
          <td>{{ dataInfo.productNum }}</td>
          <th>终端地址</th>
          <td>{{ dataInfo.address }}</td>
        </tr>
        <tr>
          <th>抵款日期</th>
          <td>{{ dataInfo.receipttime }}</td>
          <th>抵款金额</th>
          <td>
            <span style="color:#409EFF;font-weight: 500;margin-right: 6px;"><i class="el-icon-coin"></i> {{dataInfo.money}}</span>
            <el-tag :disable-transitions="true" size="mini" type="danger">{{creditPercentage}}%</el-tag>
          </td>
          <th>总金额</th>
          <td>
            <span style="margin-right: 6px;font-weight: 500;"><i class="el-icon-coin"></i> {{dataInfo.totalamount}}</span>
            <el-tag :disable-transitions="true" size="mini" v-if="dataInfo.discount>0" type="danger">{{dataInfo.discount}}折</el-tag>
            <el-tag :disable-transitions="true" size="mini" v-if="dataInfo.discount<=0" type="info">0折</el-tag>
          </td>
        </tr>
        <tr>
          <th>收款性质</th>
          <td>
            <span v-if="dataInfo.type===0||dataInfo.type===3||dataInfo.type===9">订单收款</span>
            <span v-if="dataInfo.type===4">收款抹零</span>
            <span v-if="dataInfo.type===5">返点抵款</span>
            <span v-if="dataInfo.type===6">售后赔款</span>
            <span v-if="dataInfo.type===7">报备金冲抵</span>
          </td>
          <th>收款内容</th>
          <td>{{dataInfo.paycontent}}</td>
          <th>卡号</th>
          <td>{{ dataInfo.card }}</td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="5">{{ dataInfo.remark }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewReportVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getPaycontent, getCashIncomeStatementList, printCashIncomeStatement, getDealerAccountRebateById, getDealerAccountAfterById, getDealerAccountReportById, excelCashIncomeStatement } from '@/api/erp'
import { getLodop } from '@/common/Lodop/LodopFuncs'

export default {
  name: 'xjsrdzd',
  computed: {
    user: getUser
  },
  data() {
    return {
      paycontentList: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      searchForm: {
        time: [],
        paycontent: null,
        type: null,
        opertime: []
      },
      tableData: [],
      loading: false,
      pringLoading: false,
      dataInfo: [],
      creditPercentage: 0,
      collectRecordVisible: false,
      viewRebateVisible: false,
      viewRebateLoading: false,
      viewRebatedata: [],
      imgRebateSrcList: [],
      viewAfterVisible: false,
      viewAfterLoading: false,
      imgAfterSrcList: [],
      viewAfterdata: [],
      viewReportVisible: false,
      viewReportLoading: false,
      viewReportdata: [],
      imgReportSrcList: [],
      viewReportAddress: [],
      viewReportDiscount: [],
      viewReportAcccount: [],
      excelLoading: false
    }
  },
  created() {
    getPaycontent().then(response => {
      this.paycontentList = response.data
    }).catch(() => {})
    this.getData()
  },
  methods: {
    Search() {
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    getData() {
      this.loading = true
      let starttime = ''
      let endtime = ''
      if (this.searchForm.time !== null && this.searchForm.time !== undefined) {
        if (this.searchForm.time.length === 2) {
          starttime = this.searchForm.time[0]
          endtime = this.searchForm.time[1]
        }
      }
      let operstarttime = ''
      let operendtime = ''
      if (this.searchForm.opertime !== null && this.searchForm.opertime !== undefined) {
        if (this.searchForm.opertime.length === 2) {
          operstarttime = this.searchForm.opertime[0]
          operendtime = this.searchForm.opertime[1]
        }
      }
      const data = {
        paycontent: this.searchForm.paycontent,
        type: this.searchForm.type,
        content: this.searchForm.search,
        starttime: starttime,
        endtime: endtime,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid,
        operstarttime: operstarttime,
        operendtime: operendtime
      }
      getCashIncomeStatementList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        // console.log(response.data)
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    Print() {
      const LODOP = getLodop()
      if (LODOP !== null && LODOP !== undefined) {
        if (!this.pringLoading) {
          let starttime = ''
          let endtime = ''
          if (this.searchForm.time !== null && this.searchForm.time !== undefined) {
            if (this.searchForm.time.length === 2) {
              starttime = this.searchForm.time[0]
              endtime = this.searchForm.time[1]
            }
          }
          let operstarttime = ''
          let operendtime = ''
          if (this.searchForm.opertime !== null && this.searchForm.opertime !== undefined) {
            if (this.searchForm.opertime.length === 2) {
              operstarttime = this.searchForm.opertime[0]
              operendtime = this.searchForm.opertime[1]
            }
          }
          if (this.total > 400) {
            if (starttime === '' && operstarttime === '') {
              this.$message({
                message: '由于数据量过多，请选择打款日期或操作日期区间再打印',
                type: 'warning'
              })
              return false
            }
          }
          this.pringLoading = true
          const data = {
            paycontent: this.searchForm.paycontent,
            type: this.searchForm.type,
            content: this.searchForm.search,
            starttime: starttime,
            endtime: endtime,
            userid: this.user.dUserid,
            operstarttime: operstarttime,
            operendtime: operendtime
          }
          printCashIncomeStatement(data).then(response => {
            this.pringLoading = false
            LODOP.PRINT_INIT('现金收入对账单打印')
            LODOP.SET_PRINT_PAGESIZE(2, 0, 0, 'A4')
            LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
            LODOP.ADD_PRINT_TABLE(30, 1, '100%', '100%', response.data)
            LODOP.SET_PRINT_STYLEA(0, 'HOrient', 3)
            LODOP.SET_PRINT_STYLEA(0, 'VOrient', 3)
            LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1)
            LODOP.NewPageA()
            LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 100)
            LODOP.PREVIEW()
          }).catch(() => {
            this.pringLoading = false
          })
        }
      }
    },
    exportExcel() {
      let starttime = ''
      let endtime = ''
      if (this.searchForm.time !== null && this.searchForm.time !== undefined) {
        if (this.searchForm.time.length === 2) {
          starttime = this.searchForm.time[0]
          endtime = this.searchForm.time[1]
        }
      }
      let operstarttime = ''
      let operendtime = ''
      if (this.searchForm.opertime !== null && this.searchForm.opertime !== undefined) {
        if (this.searchForm.opertime.length === 2) {
          operstarttime = this.searchForm.opertime[0]
          operendtime = this.searchForm.opertime[1]
        }
      }
      if (this.total > 400) {
        if (starttime === '' && operstarttime === '') {
          this.$message({
            message: '由于数据量过多，请选择打款日期或操作日期区间再导出',
            type: 'warning'
          })
          return false
        }
      }
      this.$message({
        message: '数据正在导出，请稍候'
      })
      this.excelLoading = true
      const data = {
        paycontent: this.searchForm.paycontent,
        type: this.searchForm.type,
        content: this.searchForm.search,
        starttime: starttime,
        endtime: endtime,
        userid: this.user.dUserid,
        operstarttime: operstarttime,
        operendtime: operendtime
      }
      excelCashIncomeStatement(data).then(response => {
        const _this = this
        let xhr = new XMLHttpRequest()
        xhr.open('GET', response.data.dPath, true)
        xhr.responseType = 'blob'
        xhr.onload = function() {
          if (this.status === 200) {
            let blob = this.response
            let a = document.createElement('a')
            a.download = response.data.dName + '.' + response.data.dType
            a.href = window.URL.createObjectURL(blob)
            a.target = '_blank'
            a.click()
            _this.excelLoading = false
            const h = _this.$createElement
            _this.$msgbox({
              title: '下载提示',
              message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                h('a',
                  { attrs: {
                    href: window.URL.createObjectURL(blob),
                    target: '_blank',
                    download: `${response.data.dName}.${response.data.dType}`,
                    style: 'color: #409EFF;text-decoration:underline;'
                  }}, `点击这里`),
                h('span', null, `重新下载。`)
              ]),
              showCancelButton: false,
              confirmButtonText: '关闭',
              beforeClose: (action, instance, done) => {
                done()
              }
            }).then(action => {
            })
          }
        }
        xhr.send()
      }).catch(() => {
        this.excelLoading = false
      })
    },
    goOrder(orderid) {
      this.collectRecordVisible = false
      this.viewRebateVisible = false
      this.viewReportVisible = false
      this.viewAfterVisible = false
      this.$router.push({ path: '/work/order/' + orderid })
    },
    openDetails(row) {
      this.dataInfo = row
      this.creditPercentage = (row.money / row.totalamount * 100).toFixed(2)
      if (row.type === 5 && row.dataid !== 0) {
        this.imgRebateSrcList = []
        this.viewRebateVisible = true
        this.viewRebateLoading = true
        getDealerAccountRebateById({ darid: row.dataid }).then(response => {
          this.viewRebateLoading = false
          this.viewRebatedata = response.data.dar
          let imgs = []
          for (let c of response.data.imgs) {
            imgs.push(c.img_url)
          }
          this.imgRebateSrcList = imgs
        }).catch(() => {
          this.viewRebateLoading = false
        })
      } else if (row.type === 6 && row.dataid !== 0) {
        this.imgAfterSrcList = []
        this.viewAfterVisible = true
        this.viewAfterLoading = true
        getDealerAccountAfterById({ daaid: row.dataid }).then(response => {
          this.viewAfterLoading = false
          this.viewAfterdata = response.data.daa
          let imgs = []
          for (let c of response.data.imgs) {
            imgs.push(c.img_url)
          }
          this.imgAfterSrcList = imgs
        }).catch(() => {
          this.viewAfterLoading = false
        })
      } else if (row.type === 7 && row.dataid !== 0) {
        this.imgReportSrcList = []
        this.viewReportVisible = true
        this.viewReportLoading = true
        getDealerAccountReportById({ darid: row.dataid }).then(response => {
          this.viewReportLoading = false
          this.viewReportdata = response.data.dar
          this.viewReportAddress = response.data.daralst
          this.viewReportDiscount = response.data.dardlst
          this.viewReportAcccount = response.data.acccount
          let imgs = []
          for (let c of response.data.imgs) {
            imgs.push(c.img_url)
          }
          this.imgReportSrcList = imgs
        }).catch(() => {
          this.viewReportLoading = false
        })
      } else {
        this.collectRecordVisible = true
      }
    }
  }
}
</script>

<style scoped>

</style>
